let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jle6Z"), load("gixIb")]).then(() => parcelRequire('6X2vu'));